import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import { Everything } from '@hit/amorphic-types';

@supertypeClass({ toClient: true, toServer: true })
export class Settings extends Everything {
  @property({
    rule: ['numeric'],
    min: 30,
    max: 100,
    validate: 'isWithin(30, 100)',
    values: {
      '50': '50',
      '51': '51',
      '52': '52',
      '53': '53',
      '54': '54',
      '55': '55',
      '56': '56',
      '57': '57',
      '58': '58',
      '59': '59',
      '60': '60',
      '61': '61',
      '62': '62',
      '63': '63',
      '64': '64',
      '65': '65',
      '66': '66',
      '67': '67',
      '68': '68',
      '69': '69',
      '70': '70',
      '71': '71',
      '72': '72',
      '73': '73',
      '74': '74',
      '75': '75',
    },
  })
  retirementAge: number = 65;

  @property({ rule: ['numeric'], min: 30, max: 120, validate: 'isWithin(30, 120)' })
  mortalityAge: number = 90;

  @property({
    values: {
      '16': '16',
      '17': '17',
      '18': '18',
      '19': '19',
      '20': '20',
      '21': '21',
      '22': '22',
      '23': '23',
      '24': '24',
      '25': '25',
    },
  })
  leaveTheNestAge: number = 21;

  @property()
  inflation: number = 0.025;

  @property()
  collegeInflation: number = 0.08;

  @property()
  discountRate: number = 0.04;

  @property()
  retirementRate: number = 0.05;

  constructor() {
    super();
  }

  static new() {
    return new Settings().init();
  }

  init() {
    return this;
  }
}
